import { Button } from 'components/ui';
import { ImageIcon } from 'components/icons';
import { formatMoney, formatRelativeTime } from 'lib/formatters';
import { OrderStatusBadge } from './OrderStatusBadge';

/** One order line item (flattened), with tab-specific actions. */
export function OrderItemCard({ entry, tab, onReject, onMarkReady, isMarkingReady }) {
  const { item, order } = entry;
  const name = item.productName || 'Item';
  const unitSize = [item.unitSize, item.unit].filter(Boolean).join(' ');
  const amount = item.vendorPaymentAmount || item.vendorTotalPrice || item.totalPrice;

  return (
    <div className="panel p-4">
      <div className="flex gap-3">
        <div className="h-14 w-14 shrink-0 overflow-hidden rounded-lg bg-surface-100">
          {item.productImageThumbnail ? (
            <img
              src={item.productImageThumbnail}
              alt={name}
              loading="lazy"
              className="h-full w-full object-cover"
            />
          ) : (
            <span className="flex h-full items-center justify-center text-slate-300">
              <ImageIcon className="h-6 w-6" />
            </span>
          )}
        </div>

        <div className="min-w-0 flex-1">
          <p className="line-clamp-2 text-sm font-medium text-slate-900">{name}</p>
          <p className="mt-0.5 text-xs text-slate-500">
            Order #{order.orderNumber || '—'} · Qty {item.quantity}
            {unitSize ? ` × ${unitSize}` : ''}
          </p>
          <p className="text-xs text-slate-400">{formatRelativeTime(order.createdAt)}</p>
        </div>

        <div className="flex shrink-0 flex-col items-end gap-1.5">
          <span className="text-sm font-semibold text-slate-900">{formatMoney(amount)}</span>
          <OrderStatusBadge status={item.status} />
        </div>
      </div>

      {item.uniqueCodeOtp && (
        <div className="mt-3 flex items-center justify-between rounded-lg bg-brand-50 px-3 py-2">
          <span className="text-xs font-medium text-brand-800">Pickup code</span>
          <span className="font-mono text-sm font-semibold text-brand-800">{item.uniqueCodeOtp}</span>
        </div>
      )}

      {tab === 'received' && (
        <div className="mt-3 flex items-center justify-end gap-2 border-t border-surface-200 pt-3">
          <button
            type="button"
            onClick={() => onReject(item)}
            className="rounded-lg px-3 py-1.5 text-sm font-medium text-red-600 transition hover:bg-red-50"
          >
            Reject
          </button>
          <Button size="sm" isLoading={isMarkingReady} onClick={() => onMarkReady(item)}>
            Mark ready
          </Button>
        </div>
      )}
    </div>
  );
}

export default OrderItemCard;
